<div class="file-upload-form-field" [ngStyle]="{ 'max-width': maxWidth() }">
  <div class="file-upload-container">
    <div>


      <!-- Label -->
      @if (label()) {
        <p class="file-upload-label">
          {{ label() }}
        </p>
      }
      @if (!label()) {
        <p  class="accepted-formats bold">
          Document Types Accepted: {{ acceptedFormats().join(', ') }}
        </p>
      }

      <!-- Drop area -->
      <div
        class="drop-area"
        (dragover)="onDragOver($event)"
        (drop)="onDrop($event)"
        >
        <p>{{ placeholder() }}</p>
        <input
          type="file"
          [id]="controlName"
          [multiple]="multiple()"
          (change)="onFileSelected($event)"
          hidden
          [disabled]="control.disabled"
          />
          <label [for]="controlName" class="btn-secondary w-fit">File Upload</label>
        </div>

        <!-- Error message -->
        @if (errorMessage) {
          <p class="error-message">{{ errorMessage }}</p>
        }

        <!-- Form control errors -->
        @if (showError) {
          <div class="error-message">
            @if (control.hasError('required')) {
              <span>File Required</span>
            }
            @if (control.hasError('message')) {
              <span>
                {{ control.getError('message') }}
              </span>
            }
          </div>
        }
      </div>

      <div class="ml-4">
        @if (files.length > 0) {
          <ul class="file-list">
            @for (file of files; track file; let i = $index) {
              <li>
                {{ file.name }}
                <lib-button
                  [cssType]="'btn-icon'"
                  [icon]="'trash'"
                  [size]="'small'"
                  (click)="removeFile(i)"
                  [disabled]="control.disabled"
                  >
                </lib-button>
              </li>
            }
          </ul>
        }
      </div>
      <!-- File list -->
    </div>
  </div>